/**
 * Resuelve la URL de imagen que devuelven los endpoints del catalogo.
 *
 * El backend devuelve una ruta local ('/storage/productos/36444.jpg') cuando el
 * fichero esta en disco y una URL absoluta del CDN
 * ('https://static.elektro3.com/assets/productos/08752.jpg') cuando no, y las
 * dos formas pueden convivir en la misma respuesta.
 *
 * Por eso no se puede concatenar el host a ciegas como hace ArticlesList.vue
 * (apiUrl + item.thumbnail): con una URL ya absoluta produciria
 * 'http://localhost:8080https://static.elektro3.com/...' y ninguna imagen
 * cargaria.
 */
const useCatalogueImage = () => {

    const imageUrl = (image) => {
        if (!image) return ''

        if (image.startsWith('http://') || image.startsWith('https://')) return image

        return process.env.VUE_APP_API_URL_IMAGES + image
    }

    return { imageUrl }
}

export default useCatalogueImage
